import { render, staticRenderFns } from "./TheCustomer.vue?vue&type=template&id=15d5b412&scoped=true&lang=pug&"
import script from "./TheCustomer.vue?vue&type=script&lang=js&"
export * from "./TheCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5b412",
  null
  
)

export default component.exports